import React, { useEffect } from 'react';
import AppRoutes from './routes/AppRoutes';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { io } from 'socket.io-client';
import {
  NOTIFICATION_RECEIVED_EVENT,
  NOTIFICATION_SOCKET_REGISTER_EVENT,
  NOTIFICATION_TOAST_CLICK_EVENT,
} from './services/notificationApi';

// components
import MaintenancePage from "./pages/MaintenancePage";

function App() {
  useEffect(() => {
    // ✅ URL ของ Socket Server ใหม่ (Render)
    const SOCKET_URL =
      process.env.NODE_ENV === 'production'
        ? 'https://socket-server-h4f6.onrender.com' // Render URL ของคุณ
        : 'http://localhost:8080'; // ถ้ารัน socket-server local

    // ✅ เชื่อมต่อกับ Socket Server โดยตรง
    const socket = io(SOCKET_URL, {
      transports: ['websocket'], // เร็วสุด เสถียรสุด
      reconnectionAttempts: 5, // ลองเชื่อมใหม่สูงสุด 5 ครั้ง
    });

    // ✅ ลงทะเบียน email user ใน socket room
    // เรียกซ้ำได้: ตอน (re)connect และตอนกระดิ่งแจ้งเตือน mount หลัง login
    const registerUser = () => {
      const user = JSON.parse(localStorage.getItem('user'));
      if (!socket.connected || !(user?.username || user?.email)) return;
      const userEmail = (user.username || user.email).toLowerCase().trim();
      socket.emit('register', userEmail);
      console.log(`📩 Socket registered as ${userEmail}`);
    };

    // ✅ Log ตอนเชื่อมต่อ / ตัดการเชื่อมต่อ
    socket.on('connect', () => {
      console.log(`🟢 Socket connected: ${socket.id}`);
      registerUser();
    });

    socket.on('disconnect', (reason) => {
      console.warn(`🔴 Socket disconnected (${reason})`);
    });

    window.addEventListener(NOTIFICATION_SOCKET_REGISTER_EVENT, registerUser);

    // ✅ รับข้อความแจ้งเตือนจาก Socket Server
    socket.on('notification', (data) => {
      console.log('📢 Notification received:', data);
      const toastText = [data?.title, data?.message].filter(Boolean).join('\n');
      if (toastText) {
        toast.info(toastText, {
          position: 'bottom-right',
          autoClose: 4000,
          theme: 'colored',
          // กระดิ่งใน Header จะโหลดรายการใหม่แล้วเปิด link ของรายการล่าสุด
          onClick: () =>
            window.dispatchEvent(new Event(NOTIFICATION_TOAST_CLICK_EVENT)),
        });
      }
      // ให้กระดิ่งใน Header โหลด badge / รายการใหม่
      window.dispatchEvent(
        new CustomEvent(NOTIFICATION_RECEIVED_EVENT, { detail: data })
      );
    });

    // ✅ cleanup ตอน component unmount
    return () => {
      window.removeEventListener(NOTIFICATION_SOCKET_REGISTER_EVENT, registerUser);
      socket.disconnect();
      console.log('🧹 Socket disconnected on cleanup');
    };
  }, []);

  const isMaintenance = process.env.REACT_APP_MAINTENANCE === "true";

  if (isMaintenance) {
    return <MaintenancePage />;
  }


  return (
    <>
      <ToastContainer />
      <AppRoutes />
    </>
  );
}

export default App;
